import { render, staticRenderFns } from "./EditorBar.vue?vue&type=template&id=e1889fb6&"
import script from "./EditorBar.vue?vue&type=script&lang=js&"
export * from "./EditorBar.vue?vue&type=script&lang=js&"
import style0 from "./EditorBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports